import React from "react";

const Msme = ({ courseDetailsData }) => {
  // Extract MSME-specific data from the API response
  const msmeData = {
    title: courseDetailsData?.title || "E-Commerce Business Program",
    subtitle:
      courseDetailsData?.subtitle || "Dive into the dynamic world of online business",
    overview: courseDetailsData?.overview || "",
    bestSuitFor: courseDetailsData?.bestSuitFor || [],
    keyTakeAways: courseDetailsData?.keyTakeAways || [],
    faqs: courseDetailsData?.faq || [],
  };

  // Create dynamic MSME support data
  const msmSupportData = [
    {
      title: `Empowered MSMEs with ${msmeData.title}`,
      // description: msmeData.subtitle,
      description:
        "The program is designed specifically to help micro, small, and medium enterprises build and enhance their digital capabilities for the online marketplace.",
    },
    {
      title: "Focused on essential e-commerce skills",
      // description:
      //   msmeData.keyTakeAways.length > 0
      //     ? `Participants learn key skills including: ${msmeData.keyTakeAways.join(
      //         ", "
      //       )}`
      //     : "Participants learn essential e-commerce skills for business growth.",
      description:
        "Participants learn how to set up digital storefronts, implement effective online marketing strategies, engage customers, and use data analytics for smarter decision-making.  ",
    },
    {
      title: "Specifically designed for MSME needs",
      // description: msmeData.bestSuitFor.includes("MSMEs")
      //   ? "This program is specially tailored for Micro, Small and Medium Enterprises looking to transition online."
      //   : "The curriculum addresses challenges faced by small and medium businesses in the digital space.",
      description:
        "The curriculum tackles real-world obstacles such as limited resources, competing with larger brands, and finding effective ways to reach and retain online customers.",
    },
    {
      title: "Practical outcomes for your business",
      // description:
      //   "MSME participants report increased online sales, better customer reach, and improved operational efficiency after completing the program.",
      description:
        "MSMEs reported increased online sales, better customer acquisition and retention, and greater operational efficiency after completing the program.",
    },
  ];

  // Find FAQ specifically about MSMEs
  const msmeFaq = msmeData.faqs.find(
    (faq) =>
      faq.question.toLowerCase().includes("msme") ||
      faq.answer.toLowerCase().includes("msme")
  );

  return (
    <div className="max-w-7xl mx-auto px-4 text-center">
      {/* Heading */}
      <div className="
  pb-1 sm:pb-2 md:pb-3
  w-full
  pt-2 sm:pt-4 md:pt-5
  font-[Figtree]
  font-semibold
  text-[34px] sm:text-[42px] lg:text-[55px]
  leading-[150%]
  tracking-[-0.03em]
  text-center
  text-[#02054C]
">
  MSMEs Support
</div>
      <p className="font-[Figtree] font-medium text-[20px] leading-[21px] text-[#818285] text-center max-w-2xl mx-auto">
        {msmeData.subtitle}
      </p>

      {/* Grid of boxes */}
      <div className="mt-12 max-w-5xl mx-auto grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
        {msmSupportData.map(({ title, description, highlight }, index) => (
          <div
            key={index}
            className={`group rounded-2xl border border-[#1D83F8] p-6 text-left transition-colors duration-300
        ${
          highlight
            ? "bg-[#1D83F8] text-white border-none"
            : "bg-white text-black hover:bg-[#1D83F8]"
        }`}
          >
            {/* Title */}
            <h3
  className="
    pt-6

    font-[Figtree]

    font-semibold

    text-[26px]

    leading-[125%]

    tracking-[0]

    text-[#02054C]

    transition-colors
    duration-300

    group-hover:text-white

    mb-3
  "
>
  {title}
</h3>

            {/* Description */}
            <p className="font-[Figtree] font-normal text-[20px] leading-[1.5] tracking-[-0.04em] text-[#1E1E1E] transition-colors duration-300 group-hover:text-white">
              {description}
            </p>
          </div>
        ))}
      </div>

      {/* Additional MSME-specific FAQ if available */}
      {msmeFaq && (
        <div className="mt-12 bg-gray-50 p-6 rounded-lg text-left max-w-4xl mx-auto">
          <h3 className="font-semibold text-xl text-[#1D83F8] mb-3">
            {msmeFaq.question}
          </h3>
          <p className="text-gray-700">{msmeFaq.answer}</p>
        </div>
      )}
    </div>
  );
};

export default Msme;
